@if (data.title) {
  <h2 mat-dialog-title>{{ data.title }}</h2>
}
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if ((data.cancelButtonStyle ?? 'basic') === 'raised') {
    <button mat-raised-button [color]="data.cancelButtonColor || 'primary'" (click)="onCancel()">{{ data.cancelButtonText || 'Cancelar' }}</button>
  } @else {
    <button mat-button (click)="onCancel()">{{ data.cancelButtonText || 'Cancelar' }}</button>
  }
  <button mat-raised-button [color]="data.confirmButtonColor ?? 'warn'" (click)="onConfirm()">{{ data.confirmButtonText }}</button>
</mat-dialog-actions>
